import React from 'react';

const UserContext = React.createContext({});
const UserProvider = UserContext.Provider;
export { UserProvider };

export default function (Component) {
  const Hoc = props => (
    <UserContext.Consumer>
      {(value) => {
        const { user, logout } = value;
        return <Component {...props} user={user} logout={logout} />;
      }}
    </UserContext.Consumer>
  );
  return Hoc;
}



// WEBPACK FOOTER //
// ./src/login/withUser.jsx